import { createContext } from 'react';

import { AuthApiError, User } from '@ergeon/erg-auth';

type AuthContextType = {
  user?: User,
  error?: AuthApiError,
  isLoading: boolean,
  authenticate: () => void;
  logout: () => void;
}

const defaultValue = {
  isLoading: false,
  authenticate: () => {
    console.info('Calling dummy auth method');
  },
  logout: () => {
    console.info('Calling dummy logout method');
  },
};

export const AuthContext = createContext<AuthContextType>(defaultValue);
